<template>
  <div>
    <slot :percentage="Math.min(+value, +max) * 100 / +max" />
  </div>
</template>

<script lang="ts" setup>
const { max = 100, value = 0 } = defineProps<{
  max?: number | string // Defines maximum (total) value that can be achieved
  value?: number | string // Defines current value
}>()
defineSlots<{
  default: (props: { percentage: number }) => void
}>()
</script>
